export enum UserCompanyTypeEnum {
  PrivateStock = 1,
  PublicStock = 2,
  LimitedLiability = 3,
  GeneralPartnership = 4,
  StateOwned = 5,
  Ministry = 6,
  Embassy = 7,
  Mosque = 8,
  School = 9,
  NGO = 10,
  Other = 11,
  Institute = 12
}

export const UserCompanyTypeLabel: Record<UserCompanyTypeEnum, string> = {
  [UserCompanyTypeEnum.PrivateStock]: 'سهامی خاص',
  [UserCompanyTypeEnum.PublicStock]: 'سهامی عام',
  [UserCompanyTypeEnum.LimitedLiability]: 'مسئولیت محدود',
  [UserCompanyTypeEnum.GeneralPartnership]: 'تضامنی',
  [UserCompanyTypeEnum.StateOwned]: 'دولتی',
  [UserCompanyTypeEnum.Ministry]: 'وزارتخانه',
  [UserCompanyTypeEnum.Embassy]: 'سفارتخانه',
  [UserCompanyTypeEnum.Mosque]: 'مسجد',
  [UserCompanyTypeEnum.School]: 'مدرسه',
  [UserCompanyTypeEnum.NGO]: 'NGO',
  [UserCompanyTypeEnum.Institute]: 'موسسه',
  [UserCompanyTypeEnum.Other]: 'سایر'
};
